var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep6To2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 82,
    viewBox: "0 0 488 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2929 0.292931C7.68342 -0.0975952 8.31659 -0.0975952 8.70711 0.292931L15.0711 6.65689C15.4616 7.04742 15.4616 7.68058 15.0711 8.07111C14.6805 8.46163 14.0474 8.46163 13.6569 8.07111L8 2.41425L2.34315 8.0711C1.95262 8.46162 1.31946 8.46162 0.928934 8.0711C0.53841 7.68058 0.53841 7.04741 0.928934 6.65689L7.2929 0.292931ZM467 33.0909L28 33.091L28 31.091L467 31.0909L467 33.0909ZM7 12.091L7 1.00004L9 1.00004L9 12.091L7 12.091ZM488 52.0909L488 82L486 82L486 52.0909L488 52.0909ZM28 33.091C16.402 33.091 7 23.689 7 12.091L9 12.091C9 22.5844 17.5066 31.091 28 31.091L28 33.091ZM467 31.0909C478.598 31.0909 488 40.493 488 52.0909L486 52.0909C486 41.5975 477.493 33.0909 467 33.0909L467 31.0909Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6To2);
export default __webpack_public_path__ + "static/media/step_6_to_2.ce7fb413362217bf101f6d77c1125df7.svg";
export { ForwardRef as ReactComponent };